// src/utils/astroUtils.js

export const standardPlanets = [
  "Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu", "Ascendant (Lagna)"
];

// Mock planetary angles (in degrees from 0–360)
// You can replace these later with real ephemeris calculations
export const planetAngles = {
  Sun: 120,
  Moon: 30,
  Mars: 75,
  Mercury: 150,
  Jupiter: 210,
  Venus: 300,
  Saturn: 240,
  Rahu: 0,
  Ketu: 180, // always 180° opposite Rahu
};

export const planetColors = {
  Sun: '#FF8C00',
  Moon: '#E8F0FF',
  Mars: '#FF3B3B',
  Mercury: '#2ECC71',
  Jupiter: '#FFD700',
  Venus: '#FF9ED1',
  Saturn: '#8CA5FF', // Lighter periwinkle blue (was #2C3E50)
  Rahu: '#6C5CE7',
  Ketu: '#CD6133',
  Uranus: '#00E5FF',
  Neptune: '#1B4F72',
  Pluto: '#800020',
  Gulika: '#B2BEC3', // Lighter silver-grey (was #2D3436)
  Upaketu: '#A29BFE',
  Yamakantaka: '#D4A373', // Lighter sandy brown (was #5D4037)
  Kala: '#CCCCCC', // Lighter silver (was #1A1A1A)
  Mrityu: '#F4A460', // Lighter orange-brown (was #6E2C00)
  "Ardha Prahara": '#5DADE2',
  Dhuma: '#7F8C8D',
  Vyatipata: '#8E44AD',
  Parivesha: '#F9E79F',
  Indrachapa: 'url(#rainbowGradient)', // We'll handle this specially in SVG or CSS
  AL: '#9B59B6',
  UL: '#FF7675',
  Muntha: '#F1C40F',
};

// Helper for HTML elements rendering planet colors
export const getPlanetStyle = (planetName) => {
  const pColor = planetColors[planetName] || "var(--text-primary)";
  if (pColor === 'url(#rainbowGradient)') {
    return {
      backgroundImage: 'linear-gradient(to right, red, orange, yellow, green, blue, indigo, violet)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      color: 'magenta' // fallback
    };
  }
  return { color: pColor };
};

export const rashiLords = {
  Aries: 'Mars',
  Taurus: 'Venus',
  Gemini: 'Mercury',
  Cancer: 'Moon',
  Leo: 'Sun',
  Virgo: 'Mercury',
  Libra: 'Venus',
  Scorpio: 'Mars',
  Sagittarius: 'Jupiter',
  Capricorn: 'Saturn',
  Aquarius: 'Saturn',
  Pisces: 'Jupiter'
};

export const nakshatraLords = {
  Ashwini: 'Ketu',
  Bharani: 'Venus',
  Krittika: 'Sun',
  Rohini: 'Moon',
  Mrigashira: 'Mars',
  Ardra: 'Rahu',
  Punarvasu: 'Jupiter',
  Pushya: 'Saturn',
  Ashlesha: 'Mercury',
  Magha: 'Ketu',
  'Purva Phalguni': 'Venus',
  'Uttara Phalguni': 'Sun',
  Hasta: 'Moon',
  Chitra: 'Mars',
  Swati: 'Rahu',
  Vishakha: 'Jupiter',
  Anuradha: 'Saturn',
  Jyeshtha: 'Mercury',
  Mula: 'Ketu',
  'Purva Ashadha': 'Venus',
  'Uttara Ashadha': 'Sun',
  Shravana: 'Moon',
  Dhanishta: 'Mars',
  Shatabhisha: 'Rahu',
  'Purva Bhadrapada': 'Jupiter',
  'Uttara Bhadrapada': 'Saturn',
  Revati: 'Mercury'
};

export const getRashiColor = (rashiName) => {
  const lord = rashiLords[rashiName];
  return lord ? planetColors[lord] : 'var(--text-primary)';
};

export const getNakshatraColor = (nakshatraName) => {
  const lord = nakshatraLords[nakshatraName];
  return lord ? planetColors[lord] : 'var(--text-primary)';
};


export const rashiSymbols = [
  '♈︎', // Aries
  '♉︎', // Taurus
  '♊︎', // Gemini
  '♋︎', // Cancer
  '♌︎', // Leo
  '♍︎', // Virgo
  '♎︎', // Libra
  '♏︎', // Scorpio
  '♐︎', // Sagittarius
  '♑︎', // Capricorn
  '♒︎', // Aquarius
  '♓︎', // Pisces
];

// Each Rashi spans 2.25 nakshatras = 9 padas
export function getRashiForPada(padaIndex) {
  const rashiIndex = Math.floor(padaIndex / 9); // 108 padas / 12 rashis = 9 padas per rashi
  return rashiSymbols[rashiIndex];
}
